import { useQuery } from '@tanstack/react-query';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import ErrorToast, { showToast } from '../../../components/messages/ErrorAlert';
import ApprovalSequenceTable from '../../../features/admin/approvalSequences/ApprovalTable';
import ApprovalSequenceFilters from '../../../features/admin/approvalSequences/ApprovalSequenceFilters';
import ApprovalSequenceParams from '../../../features/admin/approvalSequences/ApprovalSequenceParams';
import { getApprovalSequences } from '../../../services/admin/ApprovalSequences';
import { ApprovalSequenceSummary } from '../../../Interfaces/admin/ApprovalSequence.interface';

const ApprovalSequences = () => {
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const [backupData, setBackupData] = useState<{
    sequences: ApprovalSequenceSummary[];
    total: number;
  }>({
    sequences: [],
    total: 0,
  });
  const [backupPage, setBackupPage] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsAmount, setRowsAmount] = useState(15);
  const methods = useForm({});
  const { watch } = methods;
  const { companies, report } = watch();

  const { data, isFetching, isError } = useQuery({
    queryKey: ['getApprovalSequences', page, rowsAmount, companies, report],
    queryFn: ({ signal }) => {
      return getApprovalSequences(
        {
          page,
          amountPerPage: rowsAmount,
          companies,
          report,
        },
        signal
      );
    },
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setBackupData(data);
      setBackupPage(page);
    },
    onError: (error) => {
      showToast(
        'error',
        toast,
        'Search Approval Sequences Error',
        'An error occurred! please try again later',
        3000
      );
    },
  });

  useEffect(() => {
    setPage(0);
  }, [rowsAmount, companies, report]);

  return (
    <div className="pt-5 mx-3">
      <FormProvider {...methods}>
        <ErrorToast toastRef={toast} />
        <div className="mb-8 flex justify-content-between">
          <div className="font-bold text-35px">Approval Sequences</div>
          <Button
            onClick={() => {
              navigate('create');
            }}
            className="ml-5 h-fit buttonBackground text-white border-0 text-xl w-fit py-3 px-3 radius-10px"
          >
            New Approval Sequence
          </Button>
        </div>
        <div className="flex flex-wrap gap-3 mb-3">
          <ApprovalSequenceFilters />
          <ApprovalSequenceParams />
        </div>
        <ApprovalSequenceTable
          isFetching={isFetching}
          isError={isError}
          setPage={setPage}
          setRowsAmount={setRowsAmount}
          sequencesData={data}
          rowsAmount={rowsAmount}
          page={page}
          backupSequencesData={backupData}
          backupPage={backupPage}
        />
      </FormProvider>
    </div>
  );
};

export default ApprovalSequences;
